<div
    class="cmps-cdk-overflow-hidden cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4p cmps-cdk-mb-1"
>
    <div
        class="justify-content-between cmps-cdk-d-flex cmps-cdk-bg-color-grey-200 cmps-cdk-px-0dot5 cmps-cdk-py-0dot25"
    >
        <div class="cmps-cdk-d-flex cmps-cdk-align-items-center">
            <div class="cmps-cdk-pr-0dot5">
                <img
                    class="cmps-transcript-dialog-summary--icai"
                    src="assets/intelligent-coach-assist-icon.svg"
                    alt=""
                    aria-hidden="true"
                />
            </div>
            <div class="cmps-cdk-font-size-14p cmps-cdk-font-bold">
                {{ _i18n._11210_COACH_ASSIST_SUMMARY | translate }}
            </div>
        </div>
        <div>
            <button
                class="cmps-icon-button--no-bg"
                cmpsIconButton
                [disabled]="
                    _service.state?.didAddCommitmentNoteViaSummary === true ||
                    _service.state?.didAddObservationNoteViaSummary === true
                "
                [cmpsTooltipTrigger]="
                    _i18n._9488_ADD_COMMITMENT_NOTE | translate
                "
                (click)="_onAddCommitmentNoteClick()"
            >
                <cmps-icon svgIcon="folder-account-outline"></cmps-icon>
            </button>
            <button
                class="cmps-icon-button--no-bg"
                cmpsIconButton
                [disabled]="
                    _service.state?.didAddCommitmentNoteViaSummary === true ||
                    _service.state?.didAddObservationNoteViaSummary === true
                "
                [cmpsTooltipTrigger]="
                    _i18n._11032_ADD_OBSERVATION_NOTE | translate
                "
                (click)="_onAddObservationNoteClick()"
            >
                <cmps-icon svgIcon="account-eye-outline"></cmps-icon>
            </button>
        </div>
    </div>
    <cmps-comment
        [disabled]="
            _service.state?.didAddCommitmentNoteViaSummary !== true &&
            _service.state?.didAddObservationNoteViaSummary !== true
        "
        [ngModel]="_service.state?.transcript?.caSummary?.content"
        [ngModelOptions]="{ updateOn: 'blur' }"
        (ngModelChange)="summaryChange.emit($event)"
    ></cmps-comment>
</div>
